import en from "./en";
import es from "./es";
import de from "./de";
import it from "./it";
import fr from "./fr";
export default { en, es, de, it, fr };
